// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/finance/individual-employment-income',
        component: () =>
            import('@/pages/[organisation]/finance/individual-employment-income.vue'),
        name: 'finance.individual-employment-income.search-individual-employment-income',
        meta: {
            loginRequired: true,
            permission: 'access.finance.individual-employment-income.view-individual-employment-incomes',
        },
        children: [
            {
                path: 'create',
                component: () =>
                    import('@/pages/[organisation]/finance/individual-employment-income/create.vue'),
                name: 'finance.individual-employment-income.create-individual-employment-income',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.individual-employment-income.create-individual-employment-income',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/finance/individual-employment-income/[id].vue'),
                name: 'finance.individual-employment-income.view-individual-employment-income',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.individual-employment-income.view-individual-employment-income',
                },
                children: [
                    {
                        path: 'new-payment',
                        component: () =>
                            import(/* webpackChunkName: "finance.individual-employment-income" */ '@/pages/[organisation]/finance/individual-employment-income/individual-employment-income-payment/new.vue'),
                        name: 'finance.individual-employment-income.create-individual-employment-income-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.individual-employment-income.create-individual-employment-income-payment',
                        },
                    },
                ],
            },
            {
                path: ':id/edit-draft',
                component: () =>
                    import('@/pages/[organisation]/finance/individual-employment-income/[id]/edit-draft.vue'),
                name: 'finance.individual-employment-income.update-draft-individual-employment-income',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.individual-employment-income.update-individual-employment-income',
                },
            },
        ],
    },
];
